export const tokenRacerAbi = [
  { type: 'constructor', inputs: [], stateMutability: 'nonpayable' },
  {
    type: 'function',
    name: 'UPGRADE_INTERFACE_VERSION',
    inputs: [],
    outputs: [{ name: '', type: 'string', internalType: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'bettingToken',
    inputs: [],
    outputs: [{ name: '', type: 'address', internalType: 'contract IERC20' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'claimWinnings',
    inputs: [{ name: 'raceId', type: 'uint256', internalType: 'uint256' }],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'concludeRace',
    inputs: [
      { name: 'raceId', type: 'uint256', internalType: 'uint256' },
      {
        name: 'endTokenData',
        type: 'tuple[]',
        internalType: 'struct DataTypes.TokenData[]',
        components: [
          { name: 'fdv', type: 'uint256', internalType: 'uint256' },
          { name: 'price', type: 'uint256', internalType: 'uint256' },
          { name: 'volatility', type: 'uint256', internalType: 'uint256' },
        ],
      },
      { name: 'timestamp', type: 'uint256', internalType: 'uint256' },
      { name: 'signature', type: 'bytes', internalType: 'bytes' },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'createRace',
    inputs: [
      {
        name: 'params',
        type: 'tuple',
        internalType: 'struct DataTypes.RaceCreationParams',
        components: [
          { name: 'name', type: 'string', internalType: 'string' },
          { name: 'bettingDuration', type: 'uint256', internalType: 'uint256' },
          { name: 'raceDuration', type: 'uint256', internalType: 'uint256' },
          { name: 'creatorFeePercent', type: 'uint256', internalType: 'uint256' },
          { name: 'onBehalfOf', type: 'address', internalType: 'address' },
          { name: 'handicapEnabled', type: 'bool', internalType: 'bool' },
          { name: 'tokenIds', type: 'string[]', internalType: 'string[]' },
          { name: 'initialBets', type: 'uint256[]', internalType: 'uint256[]' },
        ],
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'feeRecipient',
    inputs: [],
    outputs: [{ name: '', type: 'address', internalType: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'getRace',
    inputs: [{ name: 'raceId', type: 'uint256', internalType: 'uint256' }],
    outputs: [
      { name: 'name', type: 'string', internalType: 'string' },
      { name: 'creator', type: 'address', internalType: 'address' },
      { name: 'bettingStartTime', type: 'uint256', internalType: 'uint256' },
      { name: 'raceStartTime', type: 'uint256', internalType: 'uint256' },
      { name: 'raceEndTime', type: 'uint256', internalType: 'uint256' },
      { name: 'creatorFeePercent', type: 'uint256', internalType: 'uint256' },
      { name: 'handicapEnabled', type: 'bool', internalType: 'bool' },
      { name: 'totalPool', type: 'uint256', internalType: 'uint256' },
      { name: 'concluded', type: 'bool', internalType: 'bool' },
      { name: 'participatingTokenIds', type: 'string[]', internalType: 'string[]' },
      { name: 'winner', type: 'string', internalType: 'string' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'getUserBets',
    inputs: [
      { name: 'raceId', type: 'uint256', internalType: 'uint256' },
      { name: 'user', type: 'address', internalType: 'address' },
    ],
    outputs: [
      { name: 'tokenIds', type: 'string[]', internalType: 'string[]' },
      { name: 'amounts', type: 'uint256[]', internalType: 'uint256[]' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'initialize',
    inputs: [
      { name: 'accessController_', type: 'address', internalType: 'address' },
      { name: 'bettingToken_', type: 'address', internalType: 'address' },
      { name: 'oracle_', type: 'address', internalType: 'address' },
      { name: 'feeRecipient_', type: 'address', internalType: 'address' },
      { name: 'maxTokensPerRace_', type: 'uint256', internalType: 'uint256' },
      { name: 'platformFeePercentRelative_', type: 'uint256', internalType: 'uint256' },
      { name: 'maxCreatorFeePercent_', type: 'uint256', internalType: 'uint256' },
      { name: 'minBettingDuration_', type: 'uint256', internalType: 'uint256' },
      { name: 'minRaceDuration_', type: 'uint256', internalType: 'uint256' },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'initializeRace',
    inputs: [
      { name: 'raceId', type: 'uint256', internalType: 'uint256' },
      {
        name: 'oracleData',
        type: 'tuple',
        internalType: 'struct DataTypes.RaceOracleData',
        components: [
          { name: 'timestamp', type: 'uint256', internalType: 'uint256' },
          { name: 'signature', type: 'bytes', internalType: 'bytes' },
          {
            name: 'tokenData',
            type: 'tuple[]',
            internalType: 'struct DataTypes.TokenData[]',
            components: [
              { name: 'fdv', type: 'uint256', internalType: 'uint256' },
              { name: 'price', type: 'uint256', internalType: 'uint256' },
              { name: 'volatility', type: 'uint256', internalType: 'uint256' },
            ],
          },
        ],
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'maxCreatorFeePercent',
    inputs: [],
    outputs: [{ name: '', type: 'uint256', internalType: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'maxTokensPerRace',
    inputs: [],
    outputs: [{ name: '', type: 'uint256', internalType: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'minBettingDuration',
    inputs: [],
    outputs: [{ name: '', type: 'uint256', internalType: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'minRaceDuration',
    inputs: [],
    outputs: [{ name: '', type: 'uint256', internalType: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'oracle',
    inputs: [],
    outputs: [{ name: '', type: 'address', internalType: 'contract ITokenRacerOracle' }],
    stateMutability: 'view',
  },
  { type: 'function', name: 'pause', inputs: [], outputs: [], stateMutability: 'nonpayable' },
  {
    type: 'function',
    name: 'paused',
    inputs: [],
    outputs: [{ name: '', type: 'bool', internalType: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'placeBets',
    inputs: [
      { name: 'raceId', type: 'uint256', internalType: 'uint256' },
      { name: 'tokenIds', type: 'string[]', internalType: 'string[]' },
      { name: 'amounts', type: 'uint256[]', internalType: 'uint256[]' },
      { name: 'onBehalfOf', type: 'address', internalType: 'address' },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'platformFeePercent',
    inputs: [],
    outputs: [{ name: '', type: 'uint256', internalType: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'proxiableUUID',
    inputs: [],
    outputs: [{ name: '', type: 'bytes32', internalType: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'raceCount',
    inputs: [],
    outputs: [{ name: '', type: 'uint256', internalType: 'uint256' }],
    stateMutability: 'view',
  },
  { type: 'function', name: 'unpause', inputs: [], outputs: [], stateMutability: 'nonpayable' },
  {
    type: 'function',
    name: 'updateFeeRecipient',
    inputs: [{ name: '_newFeeRecipient', type: 'address', internalType: 'address' }],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'updateMaxCreatorFeePercent',
    inputs: [{ name: '_newMaxFeePercent', type: 'uint256', internalType: 'uint256' }],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'updateMaxTokensPerRace',
    inputs: [{ name: '_maxTokens', type: 'uint256', internalType: 'uint256' }],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'updateMinBettingDuration',
    inputs: [{ name: '_newMinBettingDuration', type: 'uint256', internalType: 'uint256' }],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'updateMinRaceDuration',
    inputs: [{ name: '_newMinRaceDuration', type: 'uint256', internalType: 'uint256' }],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'updatePlatformFeePercent',
    inputs: [{ name: '_newFeePercent', type: 'uint256', internalType: 'uint256' }],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'upgradeToAndCall',
    inputs: [
      { name: 'newImplementation', type: 'address', internalType: 'address' },
      { name: 'data', type: 'bytes', internalType: 'bytes' },
    ],
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'event',
    name: 'BetPlaced',
    inputs: [
      { name: 'raceId', type: 'uint256', indexed: true, internalType: 'uint256' },
      { name: 'bettor', type: 'address', indexed: false, internalType: 'address' },
      { name: 'tokenId', type: 'string', indexed: false, internalType: 'string' },
      { name: 'amount', type: 'uint256', indexed: false, internalType: 'uint256' },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'FeeRecipientUpdated',
    inputs: [{ name: 'newFeeRecipient', type: 'address', indexed: false, internalType: 'address' }],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'Initialized',
    inputs: [{ name: 'version', type: 'uint64', indexed: false, internalType: 'uint64' }],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'MaxCreatorFeePercentUpdated',
    inputs: [{ name: 'newMaxFeePercent', type: 'uint256', indexed: false, internalType: 'uint256' }],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'MaxTokensPerRaceUpdated',
    inputs: [{ name: 'maxTokens', type: 'uint256', indexed: false, internalType: 'uint256' }],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'MinBettingDurationUpdated',
    inputs: [{ name: 'newMinBettingDuration', type: 'uint256', indexed: false, internalType: 'uint256' }],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'MinRaceDurationUpdated',
    inputs: [{ name: 'newMinRaceDuration', type: 'uint256', indexed: false, internalType: 'uint256' }],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'Paused',
    inputs: [{ name: 'account', type: 'address', indexed: false, internalType: 'address' }],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'PlatformFeePercentUpdated',
    inputs: [{ name: 'newFeePercent', type: 'uint256', indexed: false, internalType: 'uint256' }],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'RaceConcluded',
    inputs: [
      { name: 'raceId', type: 'uint256', indexed: true, internalType: 'uint256' },
      { name: 'winner', type: 'string', indexed: false, internalType: 'string' },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'RaceCreated',
    inputs: [
      { name: 'raceId', type: 'uint256', indexed: true, internalType: 'uint256' },
      { name: 'name', type: 'string', indexed: false, internalType: 'string' },
      { name: 'creator', type: 'address', indexed: false, internalType: 'address' },
      { name: 'tokenIds', type: 'string[]', indexed: false, internalType: 'string[]' },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'RaceInitialized',
    inputs: [{ name: 'raceId', type: 'uint256', indexed: true, internalType: 'uint256' }],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'Unpaused',
    inputs: [{ name: 'account', type: 'address', indexed: false, internalType: 'address' }],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'Upgraded',
    inputs: [{ name: 'implementation', type: 'address', indexed: true, internalType: 'address' }],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'WinningsClaimed',
    inputs: [
      { name: 'raceId', type: 'uint256', indexed: true, internalType: 'uint256' },
      { name: 'winner', type: 'address', indexed: false, internalType: 'address' },
      { name: 'amount', type: 'uint256', indexed: false, internalType: 'uint256' },
    ],
    anonymous: false,
  },
  { type: 'error', name: 'AddressEmptyCode', inputs: [{ name: 'target', type: 'address', internalType: 'address' }] },
  { type: 'error', name: 'AlreadyConcluded', inputs: [] },
  { type: 'error', name: 'BetsMismatch', inputs: [] },
  { type: 'error', name: 'BettingDurationTooShort', inputs: [] },
  { type: 'error', name: 'BettingPeriodOver', inputs: [] },
  { type: 'error', name: 'DataMismatch', inputs: [] },
  {
    type: 'error',
    name: 'ERC1967InvalidImplementation',
    inputs: [{ name: 'implementation', type: 'address', internalType: 'address' }],
  },
  { type: 'error', name: 'ERC1967NonPayable', inputs: [] },
  { type: 'error', name: 'EmptyBets', inputs: [] },
  { type: 'error', name: 'EmptyRaceName', inputs: [] },
  { type: 'error', name: 'EmptyTokenIds', inputs: [] },
  { type: 'error', name: 'EnforcedPause', inputs: [] },
  { type: 'error', name: 'ExpectedPause', inputs: [] },
  { type: 'error', name: 'FailedCall', inputs: [] },
  { type: 'error', name: 'FeeTooHigh', inputs: [] },
  { type: 'error', name: 'InvalidInitialization', inputs: [] },
  { type: 'error', name: 'InvalidToken', inputs: [] },
  { type: 'error', name: 'LengthMismatch', inputs: [] },
  { type: 'error', name: 'MaxFeeExceeded', inputs: [{ name: 'maxAllowed', type: 'uint256', internalType: 'uint256' }] },
  { type: 'error', name: 'NoWinningBet', inputs: [] },
  { type: 'error', name: 'NoWinningBets', inputs: [] },
  { type: 'error', name: 'NotInitializing', inputs: [] },
  {
    type: 'error',
    name: 'PRBMath_MulDiv_Overflow',
    inputs: [
      { name: 'x', type: 'uint256', internalType: 'uint256' },
      { name: 'y', type: 'uint256', internalType: 'uint256' },
      { name: 'denominator', type: 'uint256', internalType: 'uint256' },
    ],
  },
  {
    type: 'error',
    name: 'PRBMath_UD60x18_Log_InputTooSmall',
    inputs: [{ name: 'x', type: 'uint256', internalType: 'UD60x18' }],
  },
  { type: 'error', name: 'RaceDurationMustExceedBetting', inputs: [] },
  { type: 'error', name: 'RaceDurationTooShort', inputs: [] },
  { type: 'error', name: 'RaceNameTooLong', inputs: [] },
  { type: 'error', name: 'RaceNotEnded', inputs: [] },
  { type: 'error', name: 'RaceNotInitialized', inputs: [] },
  {
    type: 'error',
    name: 'SafeERC20FailedOperation',
    inputs: [{ name: 'token', type: 'address', internalType: 'address' }],
  },
  { type: 'error', name: 'SanctionedAddress', inputs: [] },
  { type: 'error', name: 'TooManyTokens', inputs: [] },
  { type: 'error', name: 'UUPSUnauthorizedCallContext', inputs: [] },
  {
    type: 'error',
    name: 'UUPSUnsupportedProxiableUUID',
    inputs: [{ name: 'slot', type: 'bytes32', internalType: 'bytes32' }],
  },
  { type: 'error', name: 'ZeroAddress', inputs: [] },
  { type: 'error', name: 'ZeroTotalAmount', inputs: [] },
] as const;
